import { z } from "zod";

const VALIDATION_MESSAGE = {
	refundPrice: "返金希望金額は0円以上で入力してください",
	refundPriceMax: "返金希望金額は10,000,000円以下で入力してください",
	refundReason: "返金理由は必須入力です",
	refundReasonMax: "返金理由は300文字以内で入力してください",
};

export const ReservationDetailRefundRequestInputZodSchema = z.object({
	refundPrice: z
		.number()
		.nonnegative({ message: VALIDATION_MESSAGE.refundPrice })
		.max(10_000_000, { message: VALIDATION_MESSAGE.refundPriceMax })
		.int()
		.optional() // undefined 時に、カスタムエラーとしたいので optional にしている
		.transform((value, ctx) => {
			if (value === undefined) return ctx.addIssue({ code: "custom", message: VALIDATION_MESSAGE.refundPrice });
			return value;
		}),
	refundReason: z
		.string()
		.min(1, { message: VALIDATION_MESSAGE.refundReason })
		.max(300, { message: VALIDATION_MESSAGE.refundReasonMax })
		.optional() // undefined 時に、カスタムエラーとしたいので optional にしている
		.transform((value, ctx) => {
			if (value === undefined) return ctx.addIssue({ code: "custom", message: VALIDATION_MESSAGE.refundReason });
			return value;
		}),
});

export type ReservationDetailRefundRequestInputType = z.infer<typeof ReservationDetailRefundRequestInputZodSchema>;
